import { useCallback, useRef, useSyncExternalStore } from 'react';
import { store, type EditorState } from '../state/store';

export function shallowEqual<T>(a: T, b: T): boolean {
  if (Object.is(a, b)) return true;
  if (!a || !b || typeof a !== 'object' || typeof b !== 'object') return false;
  const keys = Object.keys(a);
  return keys.length === Object.keys(b).length && keys.every(key => Object.is((a as Record<string, unknown>)[key], (b as Record<string, unknown>)[key]));
}
const identity = (state: EditorState) => state;
export function useStore<T = EditorState>(selector: (state: EditorState) => T = identity as (state: EditorState) => T, equal: (a: T, b: T) => boolean = shallowEqual): T {
  const select = useRef(selector); select.current = selector;
  const compare = useRef(equal); compare.current = equal;
  const cached = useRef<{ value: T } | null>(null);
  const snapshot = useCallback(() => {
    const value = select.current(store.get());
    if (!cached.current || !compare.current(cached.current.value, value)) cached.current = { value };
    return cached.current.value;
  }, []);
  return useSyncExternalStore(store.subscribe, snapshot, snapshot);
}
